import { createContext } from "react";
import { useState, useEffect } from 'react';

import jitlova from './img/categori/11.jpg';
import commerce from './img/categori/12.jpg';

//житлова нерухомість - 11

// Др нар 14-16 225 28кв.м.
import dr_nar_14_16_225_28_1 from './img/jitlo/dr_nar_14_16_225_28/1.JPG';
import dr_nar_14_16_225_28_2 from './img/jitlo/dr_nar_14_16_225_28/2.jpg';
import dr_nar_14_16_225_28_3 from './img/jitlo/dr_nar_14_16_225_28/3.jpg';
import dr_nar_14_16_225_28_4 from './img/jitlo/dr_nar_14_16_225_28/4.jpg';
import dr_nar_14_16_225_28_5 from './img/jitlo/dr_nar_14_16_225_28/5.JPG';
import dr_nar_14_16_225_28_6 from './img/jitlo/dr_nar_14_16_225_28/6.jpg';
import dr_nar_14_16_225_28_7 from './img/jitlo/dr_nar_14_16_225_28/7.jpg';
import dr_nar_14_16_225_28_8 from './img/jitlo/dr_nar_14_16_225_28/8.jpg';
import dr_nar_14_16_225_28_9 from './img/jitlo/dr_nar_14_16_225_28/9.JPG';
import dr_nar_14_16_225_28_10 from './img/jitlo/dr_nar_14_16_225_28/10.jpg';
import dr_nar_14_16_225_28_11 from './img/jitlo/dr_nar_14_16_225_28/11.jpg';
import dr_nar_14_16_225_28_12 from './img/jitlo/dr_nar_14_16_225_28/12.jpg';
import dr_nar_14_16_225_28_13 from './img/jitlo/dr_nar_14_16_225_28/13.jpg';
import dr_nar_14_16_225_28_14 from './img/jitlo/dr_nar_14_16_225_28/14.jpg';

// план Др нар 14-16 225 28кв.м.
import dr_nar_14_16_225_28_plan from './img/jitlo/dr_nar_14_16_225_28/plan.jpg';


// будівля Др нар 14-16 225 28кв.м.
import dr_nar_14_16_225_28_bild_1 from './img/jitlo/dr_nar_14_16_225_28/bild_1.jpg';
import dr_nar_14_16_225_28_bild_2 from './img/jitlo/dr_nar_14_16_225_28/bild_2.jpg';
import dr_nar_14_16_225_28_bild_3 from './img/jitlo/dr_nar_14_16_225_28/bild_3.jpg';

// Др нар 14-16 128 65кв.м.
import dr_nar_14_16_128_65_1 from './img/jitlo/dr_nar_14_16_128_65/1.jpg';
import dr_nar_14_16_128_65_2 from './img/jitlo/dr_nar_14_16_128_65/2.jpg';
import dr_nar_14_16_128_65_3 from './img/jitlo/dr_nar_14_16_128_65/3.jpg';
import dr_nar_14_16_128_65_4 from './img/jitlo/dr_nar_14_16_128_65/4.jpg';
import dr_nar_14_16_128_65_5 from './img/jitlo/dr_nar_14_16_128_65/5.jpg';
import dr_nar_14_16_128_65_6 from './img/jitlo/dr_nar_14_16_128_65/6.jpg';
import dr_nar_14_16_128_65_7 from './img/jitlo/dr_nar_14_16_128_65/7.jpg';
import dr_nar_14_16_128_65_8 from './img/jitlo/dr_nar_14_16_128_65/8.jpg';
import dr_nar_14_16_128_65_9 from './img/jitlo/dr_nar_14_16_128_65/9.jpg';
import dr_nar_14_16_128_65_10 from './img/jitlo/dr_nar_14_16_128_65/10.jpg';
import dr_nar_14_16_128_65_11 from './img/jitlo/dr_nar_14_16_128_65/11.jpg';
import dr_nar_14_16_128_65_12 from './img/jitlo/dr_nar_14_16_128_65/12.jpg';
import dr_nar_14_16_128_65_13 from './img/jitlo/dr_nar_14_16_128_65/13.jpg';
import dr_nar_14_16_128_65_14 from './img/jitlo/dr_nar_14_16_128_65/14.jpg';




//В.Васильківська 114 
import vasilkivska_114_1 from './img/jitlo/V.Vasilkivska_114/1.jpg';
import vasilkivska_114_2 from './img/jitlo/V.Vasilkivska_114/2.jpg';
import vasilkivska_114_3 from './img/jitlo/V.Vasilkivska_114/3.jpg';
import vasilkivska_114_4 from './img/jitlo/V.Vasilkivska_114/4.jpg';
import vasilkivska_114_5 from './img/jitlo/V.Vasilkivska_114/5.jpg';
import vasilkivska_114_6 from './img/jitlo/V.Vasilkivska_114/6.jpg';
import vasilkivska_114_7 from './img/jitlo/V.Vasilkivska_114/7.jpg';
import vasilkivska_114_8 from './img/jitlo/V.Vasilkivska_114/8.jpg';
import vasilkivska_114_9 from './img/jitlo/V.Vasilkivska_114/9.jpg';
import vasilkivska_114_10 from './img/jitlo/V.Vasilkivska_114/10.jpg';
import vasilkivska_114_11 from './img/jitlo/V.Vasilkivska_114/11.jpg';

// план В.Васильківська 114 
import plan_vasilkivska_114_1 from './img/jitlo/V.Vasilkivska_114/plan.jpg';
import marker_vanna_vasilkivska_114_1 from './img/jitlo/V.Vasilkivska_114/marker_vanna.mp4';
import marker_vhid_vasilkivska_114_1 from './img/jitlo/V.Vasilkivska_114/marker_vhid.mp4';
import marker_kimnata_vasilkivska_114_1 from './img/jitlo/V.Vasilkivska_114/marker_kimnata.mp4';
import marker_kuhnia_vasilkivska_114_1 from './img/jitlo/V.Vasilkivska_114/marker_kuhnia.mp4';
import marker_vid_vasilkivska_114_1 from './img/jitlo/V.Vasilkivska_114/marker_vid.mp4';
import marker_koridor_vasilkivska_114_1 from './img/jitlo/V.Vasilkivska_114/marker_koridor.mp4';
//будівля В.Васильківська 114 
import vasilkivska_114_bild1 from './img/jitlo/V.Vasilkivska_114/bild_1.jpg';
import vasilkivska_114_bild2 from './img/jitlo/V.Vasilkivska_114/bild_2.jpg';
import vasilkivska_114_bild3 from './img/jitlo/V.Vasilkivska_114/bild_3.jpg';
import vasilkivska_114_bild4 from './img/jitlo/V.Vasilkivska_114/bild_4.jpg';


//Хрещатик 15
import hrechatik_1 from './img/jitlo/hrechatik_15/1.jpg';
import hrechatik_2 from './img/jitlo/hrechatik_15/2.jpg';
import hrechatik_3 from './img/jitlo/hrechatik_15/3.jpg';
import hrechatik_4 from './img/jitlo/hrechatik_15/4.jpg';
import hrechatik_5 from './img/jitlo/hrechatik_15/5.jpg';
import hrechatik_6 from './img/jitlo/hrechatik_15/6.jpg';
import hrechatik_7 from './img/jitlo/hrechatik_15/7.jpg';
import hrechatik_8 from './img/jitlo/hrechatik_15/8.jpg';
import hrechatik_9 from './img/jitlo/hrechatik_15/9.jpg';
import hrechatik_10 from './img/jitlo/hrechatik_15/10.jpg';
import hrechatik_11 from './img/jitlo/hrechatik_15/11.jpg';
import hrechatik_12 from './img/jitlo/hrechatik_15/12.jpg';
import hrechatik_13 from './img/jitlo/hrechatik_15/13.jpg';
import hrechatik_14 from './img/jitlo/hrechatik_15/14.jpg';
import hrechatik_15 from './img/jitlo/hrechatik_15/15.jpg';
import hrechatik_16 from './img/jitlo/hrechatik_15/16.jpg';
//план Хрещатик 15
import plan_hrechatik from './img/jitlo/hrechatik_15/plan.png';
import hrechatik_marker1 from './img/jitlo/hrechatik_15/marker_1.mp4';
import hrechatik_marker2 from './img/jitlo/hrechatik_15/marker_2.mp4';
import hrechatik_marker3 from './img/jitlo/hrechatik_15/marker_3.mp4';
import hrechatik_marker4 from './img/jitlo/hrechatik_15/marker_4.mp4';
import hrechatik_marker5 from './img/jitlo/hrechatik_15/marker_5.mp4';
import hrechatik_marker6 from './img/jitlo/hrechatik_15/marker_6.mp4';
//будівля хрещатик 15
import hrechatik_bild1 from './img/jitlo/hrechatik_15/bild_krechatik_1.jpg';
import hrechatik_bild2 from './img/jitlo/hrechatik_15/bild_krechatik_2.jpg';
import hrechatik_bild3 from './img/jitlo/hrechatik_15/bild_krechatik_3.jpg';
import hrechatik_bild4 from './img/jitlo/hrechatik_15/bild_krechatik_4.jpg';
  




//комерційна нерухомість - 12
//Старт
import start_1 from './img/comercia/start/1.png';
import start_2 from './img/comercia/start/2.jpg';
import start_3 from './img/comercia/start/3.jpg';
import start_4 from './img/comercia/start/4.jpg';
import start_5 from './img/comercia/start/5.jpg';
import start_6 from './img/comercia/start/6.jpg';
import start_7 from './img/comercia/start/7.jpg';
import start_8 from './img/comercia/start/8.jpg';
import start_9 from './img/comercia/start/9.jpg';
import start_10 from './img/comercia/start/10.jpg';
import start_11 from './img/comercia/start/11.jpg';
import start_12 from './img/comercia/start/12.jpg';
import start_13 from './img/comercia/start/13.jpg';
import start_14 from './img/comercia/start/14.jpg';
import start_15 from './img/comercia/start/15.jpg';

// Страт будинок
import bild_start_1 from './img/comercia/start/outside1.png';
import bild_start_2 from './img/comercia/start/outside2.png';
import bild_start_3 from './img/comercia/start/outside3.jpg';
import bild_start_4 from './img/comercia/start/outside4.jpg';
import bild_start_5 from './img/comercia/start/outside5.jpg';
import plan_start from './img/comercia/start/plan_start.png';
//старт маркер
import marker_1et from './img/comercia/start/marker_1et.mp4';
import marker_2et_1 from './img/comercia/start/marker_2et_1.mp4';
import marker_2et_2 from './img/comercia/start/marker_2et_2.mp4';
import marker_2et_3 from './img/comercia/start/marker_2et_3.mp4';

//Шота Руставелі 33б
import shota_rust_33_1 from './img/comercia/shota_rust_33/1.jpg';
import shota_rust_33_2 from './img/comercia/shota_rust_33/2.jpg';
import shota_rust_33_3 from './img/comercia/shota_rust_33/3.jpg';
import shota_rust_33_4 from './img/comercia/shota_rust_33/4.jpg';
import shota_rust_33_5 from './img/comercia/shota_rust_33/5.jpg';
import shota_rust_33_6 from './img/comercia/shota_rust_33/6.jpg';
import shota_rust_33_7 from './img/comercia/shota_rust_33/7.jpg';
import shota_rust_33_8 from './img/comercia/shota_rust_33/8.jpg';
import shota_rust_33_9 from './img/comercia/shota_rust_33/9.jpg';
import shota_rust_33_10 from './img/comercia/shota_rust_33/10.jpg';


//Шота Руставелі 33б план + маркер
import shota_rust_33_plan from './img/comercia/shota_rust_33/plan.jpg';
import shota_rust_33_marker_kab1 from './img/comercia/shota_rust_33/marker_kab1.mp4';
import shota_rust_33_marker_koridor from './img/comercia/shota_rust_33/marker_koridor.mp4'
import shota_rust_33_marker_vanna from './img/comercia/shota_rust_33/marker_vanna.mp4'
import shota_rust_33_marker_toelet from './img/comercia/shota_rust_33/marker_toelet.mp4'
import shota_rust_33_marker_kab2 from './img/comercia/shota_rust_33/marker_kab2.mp4'
import shota_rust_33_marker_terasa from './img/comercia/shota_rust_33/marker_terasa.mp4'



//Шота Руставелі будинок
import shota_rust_33_bild1 from './img/comercia/shota_rust_33/bild_1.jpg';
import shota_rust_33_bild2 from './img/comercia/shota_rust_33/bild_2.jpg';
import shota_rust_33_bild3 from './img/comercia/shota_rust_33/bild_3.png';



export const FsrContext = createContext(null);
FsrContext.displayName = "FsrContext";

const AppContext = ({ children }) => {
const kategoris = [
  {
    id: 11,
    name: "Житлова нерухомість",
    foto: jitlova,
    lists: [
      {
        id: 113,
        implemented: false,
        rentsal: "Оренда",
        typeRealt: "Житло",
        kimnat: 1,
        vlasnik: "фізична особа",
        // colorvlasnik:'0da514',
        name: "бул. Миколи Міхновського 14-16",
        foto: [
          dr_nar_14_16_225_28_1,
          dr_nar_14_16_225_28_2,
          dr_nar_14_16_225_28_3,
          dr_nar_14_16_225_28_4,
          dr_nar_14_16_225_28_5,
          dr_nar_14_16_225_28_6,
          dr_nar_14_16_225_28_7,
          dr_nar_14_16_225_28_8,
          dr_nar_14_16_225_28_9,
          dr_nar_14_16_225_28_10,
          dr_nar_14_16_225_28_11,
          dr_nar_14_16_225_28_12,
          dr_nar_14_16_225_28_13,
          dr_nar_14_16_225_28_14,
        ],
        photos: [
          {
            day: dr_nar_14_16_225_28_1,
            evening: "",
          },
          {
            day: dr_nar_14_16_225_28_2,
            evening: "",
          },
          {
            day: dr_nar_14_16_225_28_3,
            evening: "",
          },
          { day: dr_nar_14_16_225_28_4, evening: "" },
          { day: dr_nar_14_16_225_28_5, evening: "" },
          { day: dr_nar_14_16_225_28_6, evening: "" },
          { day: dr_nar_14_16_225_28_7, evening: "" },
          { day: dr_nar_14_16_225_28_8, evening: "" },
          { day: dr_nar_14_16_225_28_9, evening: "" },
          { day: dr_nar_14_16_225_28_10, evening: "" },
          { day: dr_nar_14_16_225_28_11, evening: "" },
          { day: dr_nar_14_16_225_28_12, evening: "" },
          { day: dr_nar_14_16_225_28_13, evening: "" },
          { day: dr_nar_14_16_225_28_14, evening: "" },
        ],
        repair: "з ремонтом",
        fotoBild: [
          dr_nar_14_16_225_28_bild_1,
          dr_nar_14_16_225_28_bild_2,
          dr_nar_14_16_225_28_bild_3,
        ],
        interv: null,
        currency: "$",
         descrip: [
          "Оренда 1- кім квартири бул Миколи Міхновського 14-16(Дружби Народів), 11/13 пов, 28/12/4. Квартира з якісним ремонтом, тепла, є вся необхідна мебель та все необхідна побутова техніка, посудомийна машина, кондиціонер. Є підземний паркінг як бомбосховище. Зручне мобільне розташування. Поряд є все для комфортного проживання, аптеки, магазини, дитячий садок, спорт зали. Біля будинку є Нова Пошта, зоомагазин, стоматологія, салони краси. Ціна 18 000 грн",
        ],
        price: 409.09,
        priceLast: "",
        priceGRN: 18000,
        priceLastGRN: 18000,
        flor: "11 з 13",
        area: 28,
        areaAll: "28 / 12 / 4",
        hight: "2.9 м",
        priceTime: 1500,
        priceTimeGrn: 70000,
        florTime: 2,
        areaTime: 3,
        status: true,
        vip: false,
        avtoJivlenElevator: "Є",
        avtoJivlenWather: "опалення Є ",
        electricity: "7.5 кВт ",
        propisan: "",
        planImage: dr_nar_14_16_225_28_plan,
        markers: [],
        videoUrl: "",
        title: "Авеню 14-16",
        address: "Київ, бул. Миколи Міхновського 14-16",
        center: [30.540414, 50.413796],
        bearing: 80,
      nearbyPlaces: [
          {
            title: "NOVUS",
            time: "2 хв пішки",
            coords: [30.5384176, 50.414102],
        
            type: "shop",
          },
          {
            title: "Нова пошта",
            time: "4 хв пішки",
            coords: [30.537265, 50.413750],
            type: "post",
          },
          {
            title: "Метро",
            time: "8 хв пішки",
            coords: [30.545003, 50.418005],
           
            type: "metro",
          },
           {
            title: "Ліцей ",
            time: "8 хв пішки",
            coords: [30.5362163,  50.4130068],
           
    
            type: "shcool",
          },
        ],
        allApart: "475",
        allFlors: "13",
        typeBild: "новобудова",
        security: "Домофон, Консерж",
        material: "монолітно-каркасна",
        heating: "централізоване опалення",
        yearBuild: "2012",
        houseWifi: "Воля, Коло, Utels",
        shelter: "Паркінг 2 рівні",
        water: "вода є",
        tax5: false,
        war5: false,
        mit1: false,
        pens1: true,
        nota: 100,
        komis: 25,
        // зима
        jek: 405,
        waterKom: "",
        abonVoda: 47.52,
        abonGv: 24.56,
        abonWarm: 42.44,
        warm: 580,
        light: "",
        gas: 0,
        internet: "",
        ohorona: 216,
        other: 0,

        // літо
        jekSummer: 405,
        waterKomSummer: "",
        abonVodaSummer: 47.52,
        abonGvSummer: 24.56,
        abonWarmSummer: 42.44,
        warmSummer: 0,
        lightSummer: "",
        gasSummer: 0,
        internetSummer: "",
        ohoronaSummer: 216,
        otherSummer: 0,
        lichilHvp: "05.11.2028",
        lichilGvp: "05.11.2028",
        lichilWarm: "22.07.2029",
        viber: "380678367676",
        whatsapp: "380678367676",
        telegram: "Tomas2228",
        tel: "+380678367676",
      },
      {
        id: 112,
        implemented: false,
        rentsal: "Оренда",
        typeRealt: "Житло",
        kimnat: 3,
        vlasnik: "",
        // colorvlasnik:'0da514',
        name: "вул. Хрещатик 15",
        foto: [
          hrechatik_1,
          hrechatik_2,
          hrechatik_3,
          hrechatik_4,
          hrechatik_5,
          hrechatik_6,
          hrechatik_7,
          hrechatik_8,
          hrechatik_9,
          hrechatik_10,
          hrechatik_11,
          hrechatik_12,
          hrechatik_13,
          hrechatik_14,
          plan_hrechatik,
        ],

        photos: [
          {
            day: hrechatik_1,
            evening: "",
          },
          {
            day: hrechatik_2,
            evening: "",
          },
          {
            day: hrechatik_3,
            evening: "",
          },
          { day: hrechatik_4, evening: "" },
          { day: hrechatik_5, evening: "" },
          { day: hrechatik_6, evening: "" },
          { day: hrechatik_7, evening: "" },
          { day: hrechatik_8, evening: "" },
          { day: hrechatik_9, evening: "" },
          { day: hrechatik_10, evening: "" },
          { day: hrechatik_11, evening: "" },
          { day: hrechatik_12, evening: "" },
          { day: hrechatik_13, evening: "" },
          { day: hrechatik_14, evening: "" },
          { day: hrechatik_15, evening: "" },
          { day: hrechatik_16, evening: "" },
          { day: plan_hrechatik, evening: "" },
        ],
        repair: "з ремонтом",
        interv: null,
        currency: "$",
        descrip: [
          "Квартира розташована на 4/5 пов, будинку, ліфт.Загальна пл - 76м2, одна спальня - 15 м, друга спальня - 8,4 м, вітальня-кухня - 26,1 м , сумісний сан вузол. Відкритий балкон у двір в Пассаж та закритий балкон у двір на Городецького. Газова плита, та газова колонка, 2 кондиціонери. Є всі необхідні меблі та техніка.Лічильники на : вода, електроенергія, газ",
        ],
        price: 1300,
        priceLast: 1300,

        priceGRN: "",
        priceLastGRN: "",

        flor: "4 з 5",
        area: 76,
        areaAll: "76 / 49 / 8",
        hight: "3.8 м",
        priceTime: 800,
        priceTimeGrn: 5000,
        florTime: 2,
        areaTime: 3,
        status: true,
        vip: false,

        avtoJivlenElevator: "Немає",
        avtoJivlenWather: "Є від міста",
        electricity: "8 кВт ",
        planImage: plan_hrechatik,
        markers: [
          {
            id: 1,
            title: "Ванна",
            x: 80,
            y: 25,
            media: [{ type: "video", src: hrechatik_marker1 }],
          },
          {
            id: 2,
            title: "Вітальня",
            x: 45,
            y: 25,
            media: [{ type: "video", src: hrechatik_marker2 }],
          },
          {
            id: 3,
            title: "Спальня 1",
            x: 30,
            y: 25,
            media: [{ type: "video", src: hrechatik_marker3 }],
          },
          {
            id: 4,
            title: "Спальня 2",
            x: 30,
            y: 60,
            media: [{ type: "video", src: hrechatik_marker4 }],
          },
          {
            id: 5,
            title: "Балкон 1",
            x: 20,
            y: 3,
            media: [{ type: "video", src: hrechatik_marker5 }],
          },
          {
            id: 6,
            title: "Балкон 2",
            x: 20,
            y: 83,
            media: [{ type: "video", src: hrechatik_marker6 }],
          },
        ],
        videoUrl: "",
        title: "Хрещатик 15 (Пасаж)",
        address: "Київ, Хрещатик 15",
        center: [30.525516, 50.447539],
        bearing: 0,

        nearbyPlaces: [
          // {
          //   title: "NOVUS",
          //   time: "2 хв пішки",
          //   coords: [30.5384176, 50.414102],
        
          //   type: "shop",
          // },
          // {
          //   title: "Нова пошта",
          //   time: "4 хв пішки",
          //   coords: [30.537265, 50.413750],
          //   type: "post",
          // },
          // {
          //   title: "Метро",
          //   time: "8 хв пішки",
          //   coords: [30.545003, 50.418005],
           
          //   type: "metro",
          // },
          //  {
          //   title: "Ліцей ",
          //   time: "8 хв пішки",
          //   coords: [30.5362163,  50.4130068],
           
    
          //   type: "shcool",
          // },
        ],
        fotoBild: [
          hrechatik_bild4,
          hrechatik_14,
          hrechatik_bild1,
          hrechatik_bild2,
          hrechatik_bild3,
        ],
        allApart: "125",
        allFlors: "5",
        typeBild: "дореволюційний",
        security: "Кодовий замок, Консьерж",
        material: "цегляна",
        heating: "централізоване опалення",
        yearBuild: "1917",
        houseWifi: "Volia, Kyivstar",
        shelter: "3 хв. пішки",
        water: "вода є",
        tax5: false,
        war5: false,
        mit1: false,
        pens1: false,
        nota: 100,
        komis: 25,

        // зима
        jek: 800,
        waterKom: "",
        abonVoda: 47.52,
        abonGv: 0,
        abonWarm: 42.44,
        warm: 1900,
        light: "",
        gas: "",
        internet: "",
        ohorona: 1000,
        other: 45.83,

        // літо
        jekSummer: 800,
        waterKomSummer: "",
        abonVodaSummer: 47.52,
        abonGvSummer: 0,
        abonWarmSummer: 42.44,
        warmSummer: 0,
        lightSummer: "",
        gasSummer: "",
        internetSummer: "",
        ohoronaSummer: 1000,
        otherSummer: 45.83,
        //лічильники
        lichilHvp: "20.07.2026",
        lichilGvp: "",
        lichilWarm: "",
        lichilGaz: "30.07.2029",
        viber: "380678367676",
        whatsapp: "380678367676",
        telegram: "Tomas2228",
        tel: "+380678367676",
      },
       {
        id: 114,
        implemented: false,
        rentsal: "Оренда",
        typeRealt: "Житло",
        kimnat: 1,
        vlasnik: "фізична особа",
        // colorvlasnik:'0da514',
        name: "бул. Миколи Міхновського 14-16",
        foto: [
          dr_nar_14_16_128_65_1,
          dr_nar_14_16_128_65_2,
          dr_nar_14_16_128_65_3,
          dr_nar_14_16_128_65_4,
          dr_nar_14_16_128_65_5,
          dr_nar_14_16_128_65_6,
          dr_nar_14_16_128_65_7,
          dr_nar_14_16_128_65_8,
          dr_nar_14_16_128_65_9,
          dr_nar_14_16_128_65_10,
          dr_nar_14_16_128_65_11,
          dr_nar_14_16_128_65_12,
          dr_nar_14_16_128_65_13,
          dr_nar_14_16_128_65_14,
        ],
        photos: [
          {
            day: dr_nar_14_16_128_65_1,
            evening: "",
          },
          {
            day: dr_nar_14_16_128_65_2,
            evening: "",
          },
          {
            day: dr_nar_14_16_128_65_3,
            evening: "",
          },
          { day: dr_nar_14_16_128_65_4, evening: "" },
          { day: dr_nar_14_16_128_65_5, evening: "" },
          { day: dr_nar_14_16_128_65_6, evening: "" },
          { day: dr_nar_14_16_128_65_7, evening: "" },
          { day: dr_nar_14_16_128_65_8, evening: "" },
          { day: dr_nar_14_16_128_65_9, evening: "" },
          { day: dr_nar_14_16_128_65_10, evening: "" },
          { day: dr_nar_14_16_128_65_11, evening: "" },
          { day: dr_nar_14_16_128_65_12, evening: "" },
          { day: dr_nar_14_16_128_65_13, evening: "" },
          { day: dr_nar_14_16_128_65_14, evening: "" },
        ],
        repair: "з ремонтом",
        fotoBild: [
          dr_nar_14_16_225_28_bild_1,
          dr_nar_14_16_225_28_bild_2,
          dr_nar_14_16_225_28_bild_3,
        ],
        interv: null,
        currency: "$",
        descrip: [
          "Оренда 1- кім квартири бул Миколи Міхновського 14-16(Дружби Народів), 11/13 пов, 65/20/студія. Квартира з якісним ремонтом, тепла, є вся необхідна мебель та все необхідна побутова техніка, посудомийна машина, кондиціонер. Є підземний паркінг як бомбосховище. Зручне мобільне розташування. Поряд є все для комфортного проживання, аптеки, магазини, дитячий садок, спорт зали. Біля будинку є Нова Пошта, зоомагазин, стоматологія, салони краси. Ціна 25 000 грн",
        ],
        price: 568.18,
        priceLast: "",
        priceGRN: 25000,
        priceLastGRN: 25000,
        flor: "11 з 24",
        area: 65,
        areaAll: "65 / 20 / 23",
        hight: "2.9 м",
        priceTime: 1500,
        priceTimeGrn: 70000,
        florTime: 2,
        areaTime: 3,
        status: true,
        vip: false,
        avtoJivlenElevator: "Є",
        avtoJivlenWather: "опалення Є ",
        electricity: "14 кВт ",
        propisan: "",
        planImage: '',
        markers: [],
        videoUrl: "https://youtube.com/shorts/14IEmWrYkaQ?feature=share",
        title: "Авеню 14-16",
        address: "Київ, бул. Миколи Міхновського 14-16",
        center: [30.540414, 50.413796],
        bearing: 80,
        nearbyPlaces: [
          {
            title: "NOVUS",
            time: "2 хв пішки",
            coords: [30.5384176, 50.414102],
        
            type: "shop",
          },
          {
            title: "Нова пошта",
            time: "4 хв пішки",
            coords: [30.537265, 50.413750],
            type: "post",
          },
          {
            title: "Метро",
            time: "8 хв пішки",
            coords: [30.545003, 50.418005],
           
            type: "metro",
          },
           {
            title: "Ліцей ",
            time: "8 хв пішки",
            coords: [30.5362163,  50.4130068],
           
    
            type: "shcool",
          },
        ],
        allApart: "475",
        allFlors: "24",
        typeBild: "новобудова",
        security: "Домофон, Консерж",
        material: "монолітно-каркасна",
        heating: "централізоване опалення",
        yearBuild: "2012",
        houseWifi: "Воля, Коло, Utels",
        shelter: "Паркінг 2 рівні",
        water: "вода є",
        tax5: false,
        war5: false,
        mit1: false,
        pens1: true,
        nota: 100,
        komis: 0,
        // зима
        jek: 893,
        waterKom: "",
        abonVoda: 47.52,
        abonGv: 24.56,
        abonWarm: 42.44,
        warm: 1350,
        light: "",
        gas: 0,
        internet: "",
        ohorona: 216,
        other: 0,

        // літо
        jekSummer: 893,
        waterKomSummer: "",
        abonVodaSummer: 47.52,
        abonGvSummer: 24.56,
        abonWarmSummer: 42.44,
        warmSummer: 0,
        lightSummer: "",
        gasSummer: 0,
        internetSummer: "",
        ohoronaSummer: 216,
        otherSummer: 0,
        lichilHvp: "05.11.2028",
        lichilGvp: "05.11.2028",
        lichilWarm: "22.07.2029",
        viber: "380678367676",
        whatsapp: "380678367676",
        telegram: "Tomas2228",
        tel: "+380678367676",
      },

      {
        id: 111,
        implemented: false,
        rentsal: "Продаж",
        typeRealt: "Житло",
        kimnat: 1,
        vlasnik: "фізична особа",
        // colorvlasnik:'0da514',
        name: "вул. Велика Васильківська 114",
        foto: [
          vasilkivska_114_1,
          vasilkivska_114_2,
          vasilkivska_114_3,
          vasilkivska_114_4,
          vasilkivska_114_5,
          vasilkivska_114_6,
          vasilkivska_114_7,
          vasilkivska_114_8,
          vasilkivska_114_9,
          vasilkivska_114_10,
          vasilkivska_114_11,
          plan_vasilkivska_114_1,
        ],
        photos: [
          {
            day: vasilkivska_114_1,
            evening: "",
          },
          {
            day: vasilkivska_114_2,
            evening: "",
          },
          {
            day: vasilkivska_114_3,
            evening: "",
          },
          { day: vasilkivska_114_4, evening: "" },
          { day: vasilkivska_114_5, evening: "" },
          { day: vasilkivska_114_6, evening: "" },
          { day: vasilkivska_114_7, evening: "" },
          { day: vasilkivska_114_8, evening: "" },
          { day: vasilkivska_114_9, evening: "" },
          { day: vasilkivska_114_10, evening: "" },
          { day: vasilkivska_114_11, evening: "" },
        ],
        repair: "з ремонтом",
        fotoBild: [
          vasilkivska_114_bild1,
          vasilkivska_114_bild2,
          vasilkivska_114_bild3,
          vasilkivska_114_bild4,
        ],
        interv: null,
        currency: "$",
        descrip: [
          "Продаж 1-к квартири по вул Велика Васильківська, 114. Теплий цегляний будинок/Загальна площа 28,76 метри, жилтова 14,4, кухня 5,7 метрів. Висота стелі - 2,75. Розташова на на 7 поверсі 7-ми поверхового будинку, є технічний поверх. Вікна виходять у двір, що робить квартиру абсолютно тихою. Складається з кухні з великою кімнатою. Під час ремонту замінена вся електрика і сантехніка. Квартира в чудовому стані. Є балкон засклений. Під'їзд чистий в гарному стані, домофон. До метро Палац Україна 3 хвилин пішки.",
        ],
        price: 65000,
        flor: "7 з 7",
        area: 28.75,
        areaAll: "28.75 / 14.4 / 4.1",
        hight: "2.7 м",
        priceTime: 1500,
        priceTimeGrn: 70000,
        florTime: 2,
        areaTime: 3,
        status: true,
        vip: false,
        avtoJivlenElevator: "Немає",
        avtoJivlenWather: "Є від міста",
        electricity: "6 кВт ",
        propisan: "немає",
        planImage: plan_vasilkivska_114_1,
        markers: [
          {
            id: 1,
            title: "Ванна",
            x: 60,
            y: 40,
            media: [{ type: "video", src: marker_vanna_vasilkivska_114_1 }],
          },
          {
            id: 2,
            title: "Кімнтата Вхід",
            x: 68,
            y: 53,
            media: [{ type: "video", src: marker_vhid_vasilkivska_114_1 }],
          },
          {
            id: 3,
            title: "Кімнтата Вхід",
            x: 69,
            y: 81,
            media: [{ type: "video", src: marker_kimnata_vasilkivska_114_1 }],
          },
          {
            id: 4,
            title: "Кухня",
            x: 32,
            y: 53,
            media: [{ type: "video", src: marker_kuhnia_vasilkivska_114_1 }],
          },
          {
            id: 5,
            title: "Вид",
            x: 13,
            y: 73,
            media: [{ type: "video", src: marker_vid_vasilkivska_114_1 }],
          },
          {
            id: 6,
            title: "Коридор",
            x: 65,
            y: 25,
            media: [{ type: "video", src: marker_koridor_vasilkivska_114_1 }],
          },
        ],
        videoUrl: "https://youtube.com/shorts/VfnHSBz0EEo?feature=share",
        title: "Палац Україна",
        address: "Київ, вул. Велика Васильківська 114",
        center: [30.518526, 50.422662],
        bearing: 80,
        nearbyPlaces: [
          // {
          //   title: "NOVUS",
          //   time: "2 хв пішки",
          //   coords: [30.5384176, 50.414102],
        
          //   type: "shop",
          // },
          // {
          //   title: "Нова пошта",
          //   time: "4 хв пішки",
          //   coords: [30.537265, 50.413750],
          //   type: "post",
          // },
          // {
          //   title: "Метро",
          //   time: "8 хв пішки",
          //   coords: [30.545003, 50.418005],
           
          //   type: "metro",
          // },
          //  {
          //   title: "Ліцей ",
          //   time: "8 хв пішки",
          //   coords: [30.5362163,  50.4130068],
           
    
          //   type: "shcool",
          // },
        ],
        allApart: "176",
        allFlors: "7",
        typeBild: "совмін",
        security: "Домофон",
        material: "цегляна",
        heating: "централізоване опалення",
        yearBuild: "1961",
        houseWifi: "Lanet, Коло",
        shelter: "3 хв. пішки",
        water: "вода є",
        tax5: false,
        war5: false,
        mit1: false,
        pens1: true,
        nota: 100,
        komis: 0,
        // зима
        jek: 367,
        waterKom: "",
        abonVoda: 47.52,
        abonGv: 24.56,
        abonWarm: 42.44,
        warm: 550,
        light: "",
        gas: 26.55,
        internet: "",
        ohorona: 0,
        other: 45.83,

        // літо
        jekSummer: 367,
        waterKomSummer: "",
        abonVodaSummer: 47.52,
        abonGvSummer: 24.56,
        abonWarmSummer: 42.44,
        warmSummer: 0,
        lightSummer: "",
        gasSummer: 26.55,
        internetSummer: "",
        ohoronaSummer: 0,
        otherSummer: 45.83,
        lichilHvp: "20.07.2028",
        lichilGvp: "05.08.2028",
        lichilWarm: "",
        viber: "380678367676",
        whatsapp: "380678367676",
        telegram: "Tomas2228",
        tel: "+380678367676",
      },
    ],
  },

  {
    id: 12,
    name: "Комерційна нерухомість",
    foto: commerce,
    lists: [
      {
        id: 123,
        typeRealt: "Комерція",
        rentsal: "Оренда",
        kimnat: "Open-Space",
        vlasnik: "ФОП 3-група",
        name: "вулиця  Вільгельма Котарбінського 24 ЖК Старт",
        foto: [
          start_1,
          start_3,
          start_4,
          start_5,
          start_6,
          start_7,
          start_8,
          start_9,
          start_10,
          start_11,
          start_12,
          start_13,
          start_14,
          start_15,
          plan_start,
        ],
        photos: [
          {
            day: start_1,
            evening: "",
          },
          {
            day: start_3,
            evening: "",
          },
          {
            day: start_4,
            evening: "",
          },
          { day: start_5, evening: "" },
          { day: start_6, evening: "" },
          { day: start_7, evening: "" },
          { day: start_8, evening: "" },
          { day: start_9, evening: "" },
          { day: start_10, evening: "" },
          { day: start_11, evening: "" },
          { day: start_12, evening: "" },
          { day: start_13, evening: "" },
          { day: start_14, evening: "" },
          { day: start_15, evening: "" },
          { day: plan_start, evening: "" },
        ],
        repair: "без ремонту",
        interv: null,
        currency: "грн",
        descrip: [
          " Оренда фасадного приміщення з окремим входом по вул. Вільгельма Котарбінського 24 в сучасному ЖК \"СТАРТ\" Загальна пл - 99,5 м². Складаєтьсяз 2-х рівнів: 1 пов - 20,3 м² та 2 пов - 79,2 м². Характеристика приміщення: висота стелі 3,2м, вентканал, централізоване опалення (лічільник), потужність по електроенергії - 15 кВт з можливістю збільшення, радіатори з терморегулятором, індивідуальні лічильники на воду, пожежна сигналізація. Є місце для вивіски. Приміщення без ремонту. Ремонтні канікули обговорюються. Підходить під: кав'ярню, книгарню, пекарню, магазин продуктів, винний магазин і тд. Поруч: метро Лук'янівська 8 хвилин пішки, та багато нових житлових комплексів.Ціна - 0 грн/міс - перші 3 місяці (канікули). Ціна - 25 000 грн/міс - з 4-го місяця по 6-тий включно. Ціна - 45 000 грн /міс - з 6-го місяця по 12- тий включно. Ціна - 65 000 грн/міс - з 13-го місяця по 24 -тий включно",
        ],
        price: 568.18,
        priceLast: "",
        priceGRN: 25000,
        priceLastGRN: 45000,

        flor: "1 та 2 з 25",
        area: 99.5,
        areaAll: "99.5 м²",
        priceTime: 800,
        priceTimeGrn: 1000,
        florTime: 2,
        areaTime: 3,
        status: true,
        vip: false,

        avtoJivlenElevator: "не потрібно",
        avtoJivlenWather: "є від міста",
        electricity: "15 кВт з можливістю збільшення",
        planImage: plan_start,
        markers: [
          {
            id: 1,
            title: "Вхід",
            x: 14,
            y: 12,
            media: [{ type: "image", src: start_1 }],
          },
          {
            id: 2,
            title: "1-й поверх",
            x: 14,
            y: 33,
            media: [{ type: "video", src: marker_1et }],
          },
          {
            id: 3,
            title: "2-й поверх 1",
            x: 90,
            y: 33,
            media: [{ type: "video", src: marker_2et_1 }],
          },
          {
            id: 4,
            title: "2-й поверх 2",
            x: 90,
            y: 65,
            media: [{ type: "video", src: marker_2et_2 }],
          },
          {
            id: 5,
            title: "2-й поверх 3",
            x: 47,
            y: 39,
            media: [{ type: "video", src: marker_2et_3 }],
          },
        ],
        videoUrl: "https://www.youtube.com/shorts/LQAvF2QwTJU",
        title: "Вільгельма Котарбінського 24 (ЖК Старт)",
        address: "Вільгельма Котарбінського 24, Київ",
        center: [30.481385, 50.457839],
        bearing: -70,

        nearbyPlaces: [
          // {
          //   title: "NOVUS",
          //   time: "2 хв пішки",
          //   coords: [30.5384176, 50.414102],
        
          //   type: "shop",
          // },
          // {
          //   title: "Нова пошта",
          //   time: "4 хв пішки",
          //   coords: [30.537265, 50.413750],
          //   type: "post",
          // },
          // {
          //   title: "Метро",
          //   time: "8 хв пішки",
          //   coords: [30.545003, 50.418005],
           
          //   type: "metro",
          // },
          //  {
          //   title: "Ліцей ",
          //   time: "8 хв пішки",
          //   coords: [30.5362163,  50.4130068],
           
    
          //   type: "shcool",
          // },
        ],

        fotoBild: [bild_start_1, bild_start_2, bild_start_3, bild_start_4],
        hight: "3.2",
        allApart: "864",
        allFlors: "25",
        typeBild: "новобудова",
        security: "охорана, відеонагляд",
        material: "монолітно-каркасна, керамоблок",
        heating: "централізоване опалення",
        yearBuild: "2023",
        houseWifi: "Utels, Kyivstar, Коло",
        shelter: "2 хв. пішки, або паркінг",
        water: "вода є",

        tax5: false,
        war5: false,
        mit1: false,
        pens1: false,
        nota: 100,
        komis: 0,

        // зима
        jek: 1473.6,
        waterKom: "",
        abonVoda: 26.23,
        abonGv: 0,
        abonWarm: 0,
        warm: "",
        light: "",
        gas: 0,
        internet: "",
        ohorona: 264.59,
        other: 34.83,

        // літо
        jekSummer: 1473.6,
        waterKomSummer: "",
        abonVodaSummer: 26.23,
        abonGvSummer: 0,
        abonWarmSummer: 0,
        warmSummer: 0,
        lightSummer: "",
        gasSummer: 0,
        internetSummer: "",
        otherSummer: 34.83,
        ohoronaSummer: 264.59,
        //лічильники
        lichilHvp: "20.11.2028",
        lichilGvp: "",
        lichilWarm: "",
        viber: "380678367676",
        whatsapp: "380678367676",
        telegram: "Tomas2228",
        tel: "+380678367676",
        location: "https://maps.app.goo.gl/Mo73CUnrpnWvvo286",
        network:
          "https://www.olx.ua/d/obyavlenie/prodam-3k-kvartiru-v-kotsyubinskomu-vul-ponomarova-26-IDXlOJY.html",
      },
      {
        id: 124,
        typeRealt: "Комерція",
        rentsal: "Оренда",
        kimnat: "2 кабінети",
        vlasnik: "",
        name: "вул. Шота Руставелі 33Б",
        foto: [
          shota_rust_33_1,
          shota_rust_33_2,
          shota_rust_33_3,
          shota_rust_33_4,
          shota_rust_33_5,
          shota_rust_33_6,
          shota_rust_33_7,
          shota_rust_33_8,
          shota_rust_33_9,
          shota_rust_33_10,
          shota_rust_33_plan,
        ],
        photos: [
          {
            day: shota_rust_33_1,
            evening: "",
          },
          {
            day: shota_rust_33_2,
            evening: "",
          },
          {
            day: shota_rust_33_3,
            evening: "",
          },
          { day: shota_rust_33_4, evening: "" },
          { day: shota_rust_33_5, evening: "" },
          { day: shota_rust_33_6, evening: "" },
          { day: shota_rust_33_7, evening: "" },
          { day: shota_rust_33_8, evening: "" },
          { day: shota_rust_33_9, evening: "" },
          { day: shota_rust_33_10, evening: "" },
          { day: shota_rust_33_plan, evening: "" },
        ],
        repair: "з ремонтом",
        interv: null,
        currency: "грн",
        descrip: [
          " Оренда офісу Печерський р-н вул Шота Руставелі 33Б. 3-й поверх, 35м² Вхід через підїзд. Жилий фонд, 2 роздільні кабінети (15,8 +7,1)м², сан вузол - розділений. Зроблений косметичний ремонт. Все в пішій доступності: Бесарабка, Палац Спорту, Олімпійська, Героїв України, Хрещатик. Ціна - 17500 грн",
        ],
        price: 397.72,
        priceLast: "",
        priceGRN: 17500,
        priceLastGRN: 17500,

        flor: "3 з 6",
        area: 35,
        areaAll: "35 м²",
        priceTime: 800,
        priceTimeGrn: 1000,
        florTime: 2,
        areaTime: 3,
        status: true,
        vip: false,

        avtoJivlenElevator: "не має",
        avtoJivlenWather: "є від міста",
        electricity: "5.5 кВт",
        planImage: shota_rust_33_plan,
        markers: [
          {
            id: 1,
            title: "Коридор",
            x: 75,
            y: 18,
            media: [{ type: "video", src: shota_rust_33_marker_koridor }],
          },
          {
            id: 2,
            title: "1-й кабінет - 15,8 м²",
            x: 58,
            y: 27,
            media: [{ type: "video", src: shota_rust_33_marker_kab1 }],
          },
          {
            id: 3,
            title: "Ванна",
            x: 33,
            y: 18,
            media: [{ type: "video", src: shota_rust_33_marker_vanna }],
          },
          {
            id: 4,
            title: "Туалет",
            x: 33,
            y: 34,
            media: [{ type: "video", src: shota_rust_33_marker_toelet }],
          },
          {
            id: 5,
            title: "Кабінет 2 - 7,1м²",
            x: 38,
            y: 42,
            media: [{ type: "video", src: shota_rust_33_marker_kab2 }],
          },
          {
            id: 6,
            title: "Тераса ",
            x: 72,
            y: 75,
            media: [{ type: "video", src: shota_rust_33_marker_terasa }],
          },
        ],
        videoUrl: "",
        title: "вул. Шота Руставелі 33Б",
        address: "вул. Шота Руставелі 33Б, Київ",
        center: [30.51913, 50.437356],
        bearing: 0,
         nearbyPlaces: [
          // {
          //   title: "NOVUS",
          //   time: "2 хв пішки",
          //   coords: [30.5384176, 50.414102],
        
          //   type: "shop",
          // },
          // {
          //   title: "Нова пошта",
          //   time: "4 хв пішки",
          //   coords: [30.537265, 50.413750],
          //   type: "post",
          // },
          // {
          //   title: "Метро",
          //   time: "8 хв пішки",
          //   coords: [30.545003, 50.418005],
           
          //   type: "metro",
          // },
          //  {
          //   title: "Ліцей ",
          //   time: "8 хв пішки",
          //   coords: [30.5362163,  50.4130068],
           
    
          //   type: "shcool",
          // },
        ],

        fotoBild: [
          shota_rust_33_bild3,
          shota_rust_33_bild1,
          shota_rust_33_bild2,
        ],
        hight: "3.3",
        allApart: "48",
        allFlors: "6",
        typeBild: "дореволюційний",
        security: "домофон",
        material: "цегляна",
        heating: "централізоване опалення",
        yearBuild: "1917",
        houseWifi: "Utels, AYOL",
        shelter: "6 хв. пішки",
        water: "вода є",

        tax5: false,
        war5: false,
        mit1: false,
        pens1: false,
        nota: 0,
        komis: 0,

        // зима
        jek: 488,
        waterKom: "",
        abonVoda: 47.52,
        abonGv: 29.3,
        abonWarm: 42.44,
        warm: 610,
        light: "",
        gas: 0,
        internet: "",
        ohorona: 0,
        other: 45.83,

        // літо
        jekSummer: 488,
        waterKomSummer: "",
        abonVodaSummer: 47.52,
        abonGvSummer: 29.3,
        abonWarmSummer: 42.44,
        warmSummer: 0,
        lightSummer: "",
        gasSummer: 0,
        internetSummer: "",
        otherSummer: 45.83,
        ohoronaSummer: 0,
        //лічильники
        lichilHvp: "20.11.2029",
        lichilGvp: "25.11.2029",
        lichilWarm: "",
        viber: "380678367676",
        whatsapp: "380678367676",
        telegram: "Tomas2228",
        tel: "+380678367676",
      },
    ],
  },
];

 const [apartAtatus, setApartAtatus] = useState([]);
    

     useEffect(() => {
      let interval;
  
      const getApartAtatus = async () => {
        try {
          const res = await fetch('https://69cad8baba5984c44bf3ee4a.mockapi.io/Apart/stats');
          if (!res.ok) {
            throw new Error('Failed to fetch restoran');
          }
          const data = await res.json();
          setApartAtatus(data);
        } catch (e) {
          console.error(e.message);
        }
      };
  
     
      getApartAtatus();


    }, []);
  

 return (
    <FsrContext.Provider value={{kategoris, apartAtatus }}>
      {children}
    </FsrContext.Provider>
  );



}

export default AppContext;


